// Standalone header/footer iframe-resizer diagnostic document (IFrameUtilTestView
// at /frameutils/test/). No site chrome and no PageSkeleton: it just embeds the
// nav + footer fragment iframes and wires up iframe-resizer. reactivated's
// renderer injects the bundle CSS/JS + __PRELOADED_PROPS__, so none of that is
// emitted here.
import React from "react";

import { templates } from "@reactivated";

import { ExternalScript } from "@thelabnyc/thelabui/src/components/ExternalScript";
import { useSSRNonce } from "@thelabnyc/thelabui/src/hooks/useSSRNonce";

export const Template = (
    props: templates.IFrameTestDocumentTemplate,
): React.JSX.Element => {
    const nonce = useSSRNonce();
    return (
        <html>
            <head>
                <title>Header / footer iframe test view</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <style>{`
                    html,
                    body {
                        padding: 0;
                        margin: 0;
                    }
                    iframe {
                        border: none;
                    }
                `}</style>
            </head>
            <body>
                <iframe
                    id="site-navigation"
                    src="/frameutils/navigation/"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-top-navigation"
                    width="100%"
                    height="115px"
                />

                <div>
                    <h1>Hello World!</h1>
                    <p>
                        {
                            "This content isn't in an iframe. But the navigation above and the footer below are iframes."
                        }
                    </p>
                </div>

                <iframe
                    id="site-footer"
                    src="/frameutils/footer/"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
                    width="100%"
                    height="1000px"
                />

                <ExternalScript src={props.iframe_resizer_url} />
                {/* window.onload waits for iframeResizer.js, which defines iFrameResize. */}
                <script
                    nonce={nonce}
                    dangerouslySetInnerHTML={{
                        __html: `window.onload = () => { iFrameResize({}, '#site-navigation'); iFrameResize({}, '#site-footer'); };`,
                    }}
                />
            </body>
        </html>
    );
};
